import { render, staticRenderFns } from "./FirmLicense.vue?vue&type=template&id=65cf486d&scoped=true&"
import script from "./FirmLicense.vue?vue&type=script&lang=js&"
export * from "./FirmLicense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cf486d",
  null
  
)

export default component.exports